// Coloque aqui os keycodes que vai precisar reutilizar
export default {
  ESC: 27,
};
